import classNames from 'classnames';
import { Default } from 'react-spinners-css';
import './Loader.styles.scss';

type LoaderProps = {
  className?: string;
  color?: string;
  size?: number;
  label?: string;
};

const Loader: React.FC<LoaderProps> = (props) => {
  const { className, label, color = '#0000fe', size = 300 } = props;

  const classes = classNames('res-loader', className);

  return (
    <div className={classes}>
      <Default color={color} size={size} />
      {label && <h4>{label}</h4>}
    </div>
  );
};

export default Loader;
